var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('compFormQuery',{attrs:{"formdata":_vm.getBase,"value":_vm.formData}}),(_vm.loading)?_c('vLoading',{attrs:{"loading":"","size":"large","fix":""}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }